import { render, staticRenderFns } from "./bind-card-success.vue?vue&type=template&id=54c209e7"
import script from "./bind-card-success.vue?vue&type=script&lang=js"
export * from "./bind-card-success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports